import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modaldialog',
  templateUrl: './modaldialog.component.html',
  styleUrls: ['./modaldialog.component.scss']
})
export class ModaldialogComponent implements OnInit {

  constructor(
    private translateService: TranslateService
    ) { }

  @Input()
  modalDialogTitle = 'title23';

  @Input()
  modalDialogBodyContent = 'bodyContent';

  @Input()
  modalDialogType = 'BLOCK_TOAST';

  @Input()
  dislayCloseButton = false;

  @Input()
  displayLeaveButton = false;

  @Input()
  displayStayButton = false;


  @Output() closeModalDialogEvent = new EventEmitter<boolean>();

  @Output() leavePageModalDialogEvent = new EventEmitter<boolean>();

  @Output() stayOnPagModalDialogEvent = new EventEmitter<boolean>();

  ngOnInit(): void {

  }

  raiseModalEvent(eventAction) {
    if (eventAction === 'stay') {
      this.stayOnPagModalDialogEvent.emit(true);
    } else if (eventAction === 'leave') {
      this.leavePageModalDialogEvent.emit(true);
    } else if (eventAction === 'close') {
      this.closeModalDialogEvent.emit(true);
    }
  }




}
